import { useEffect } from "react";
import { XCircle } from "react-feather";

import styles from "./Modal.module.css";

interface ModalProps {
  children: React.ReactNode;
  handleClose?: TypeAny;
  removePadding?: boolean;
  closeButton?: boolean;
  fullSize?: boolean;
  outsideClose?: boolean;
  modalStyles?: React.CSSProperties;
}

export function Modal({
  handleClose,
  children,
  removePadding,
  closeButton = true,
  fullSize,
  outsideClose = true,
  modalStyles,
}: ModalProps) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && typeof handleClose === "function") {
        handleClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleClose]); // Include handleClose in dependencies for proper cleanup

  useEffect(() => {
    // document.body.style.overflow = 'hidden';
    // // save current position
    const scrollPosition = window.pageYOffset;

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    return () => {
      // document.body.style.overflow = 'auto';
      document.body.style.position = "";
      document.body.style.top = "";

      window.scrollTo(0, scrollPosition);
    };
  }, []);

  return (
    <div
      data-testid="modalOverlay"
      className={`${styles.modal} ${fullSize ? styles.modalFull : ""}`}
      onClick={outsideClose ? handleClose : undefined}
      role="button"
      tabIndex={0}
      data-remove-padding={removePadding}
    >
      <div
        onClick={(e: TypeAny) => e.stopPropagation()}
        className={styles.modalChildren}
        role="button"
        tabIndex={0}
        style={modalStyles}
      >
        {closeButton && (
          <button
            className={styles.modalClose}
            data-testid="cancelButton"
            onClick={handleClose}
            type="button"
          >
            <XCircle size={24} />
          </button>
        )}
        {children}
      </div>
    </div>
  );
}
